import React from 'react';
import { motion } from 'framer-motion';

export function SettingsCard({ icon: Icon, title, children, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="settings-card"
    >
      <h3 className="settings-card__header">
        {Icon && <Icon className="w-5 h-5" style={{ color: "var(--primary-accent-blue)" }} />}
        {title}
      </h3>
      <div className="settings-card__content">
        {children}
      </div>
    </motion.div>
  );
}
